export const ZOOM_LEVEL = {
  ONE_DAY: 1,
  THREE_DAYS: 3,
  FIVE_DAYS: 5,
  TEN_DAYS: 10,
  FIVE_WEEK: 25,
  TEN_WEEK: 50,
};

export const DIVIDE_FOR_WEEK = 5;

export const DEFAULT_BACKLOG = {
  ID: 'backlog',
  NAME: 'backlog'
};